import { render, staticRenderFns } from "./PriceHeader.vue?vue&type=template&id=5ddb3556&scoped=true&"
import script from "./PriceHeader.vue?vue&type=script&lang=js&"
export * from "./PriceHeader.vue?vue&type=script&lang=js&"
import style0 from "./PriceHeader.vue?vue&type=style&index=0&id=5ddb3556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb3556",
  null
  
)

export default component.exports